const serviceData = [
  {
    icon: "ri-truck-line",
    title: "Free Shipping",
    subtitle: "Fastest delivery in your area.",
    bg: "#fdefe6",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    subtitle: "No question ask policy on return.",
    bg: "#ceebe9",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Secure Payment",
    subtitle: "Feel free to make a payment.",
    bg: "#e2f2b2",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: " Back Guarantee",
    subtitle: "100% Guarantee back policy.",
    bg: "#d6e5fb",
  },
];

export default serviceData;
